import { makeUseFetchOne } from '@elentari/core/hooks/makeUseFetchOne'
import { CentroCustoDetail } from '../types'
import { centroCustoRepository } from './centroCustoRepository'

export const useCentroCusto = makeUseFetchOne<CentroCustoDetail, string>({
  fetch: centroCustoRepository.fetchOne
})
